import { useEffect } from "react";
import userInfoStore, { getUser } from "@/store/user.store";
import { useNavigate } from "react-router-dom";
import { setLoginSize, setMainSize } from "@/utils/window";
import { message } from "antd";
import http from "@/services/http";
import useSubscribePressEvent from "@/sections/SubscribePressEvent/useSubscribePressEvent";
import { useIM } from "./useIM";

export const useInit = () => {
  const navigate = useNavigate();
  const { subscribeUseAIMicCb } = useSubscribePressEvent();
  useIM();

  useEffect(() => {
    // 只在Index页面执行，其他页面不执行
    console.log('layout location.pathname', location.pathname);
    if (location.pathname !== '/' && location.pathname !== '/edge-web/') return;
    const token = http.getToken();
    if (token) {
      const refreshToken = http.getRefreshToken();
      // 兼容旧版本
      if (!refreshToken) {
        console.log('没有 refresh token 登录信息，跳转到登录页');
        message.info("登录失效，请重新登录");
        setLoginSize();
        navigate("/login", { replace: true });
        return;
      }
      judgeCompany();
    } else {
      console.log('没有 token 信息，跳转到登录页');
      setLoginSize();
      navigate("/login", { replace: true });
    }
  }, []);

  const judgeCompany = async () => {
    const isGetInfoSuccess = await getUser();

    const alreadySwitched = userInfoStore.getState().switchOrg;
    console.log('判断是否切换过企业 = ', alreadySwitched);
    if (isGetInfoSuccess && !alreadySwitched) {
      // navigate("/login?mode=choseCompany", { replace: true });
      navigate("/login", { replace: true });
    } else {
      setTimeout(() => {
        setMainSize();
        const queryParams = new URLSearchParams(location.search);
        const starttype = queryParams.get("starttype") || "";
        if (starttype) {
          console.log("page index search 包含 starttype，执行 subscribeUseAIMicCb");
          subscribeUseAIMicCb({ starttype });
        } else {
          console.log('page index search 没有 starttype，跳转到 home');
          // 如果是在登录页则不跳转
          if (location.pathname === '/login') return;
          navigate(`/home`, { replace: true });
        }
      }, 500);
    }
  }
};
